import { getSOCReports } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const GetSOCReportList = async (accessToken) => {
  try {
    const response = await getSOCReports(accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default GetSOCReportList;
